<article
    class="rounded-md border border-white/60 bg-white/50"
    [ngClass]="[
        compact ? 'p-3' : 'p-4',
        fillHeight ? 'h-full' : ''
    ]">
    <header
        *ngIf="eyebrow || title || description"
        class="mb-3 gap-3"
        [ngClass]="headerInline ? 'flex flex-col lg:flex-row lg:items-start lg:justify-between' : 'grid'">
        <div class="min-w-0">
            <span *ngIf="eyebrow" class="block text-xs font-semibold uppercase tracking-wide text-slate-500">
                {{ eyebrow }}
            </span>
            <h3 *ngIf="title" class="m-0 text-sm font-semibold text-slate-950">
                {{ title }}
            </h3>
            <p *ngIf="description" class="mt-1 text-xs leading-relaxed text-slate-500">
                {{ description }}
            </p>
        </div>
        <ng-content select="[section-actions]"></ng-content>
    </header>

    <ng-content></ng-content>
</article>
